import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Tab from 'components/atoms/Tabs/Tab/Tab';

const StyledActionTab = styled(Tab)`
  ${ComponentStyles}
`;

StyledActionTab.propTypes = {
  theme: PropTypes.object
};

export default StyledActionTab;
